export const HTMLInputTypes = {
  BUTTON: 'button',
  CHECKBOX: 'checkbox',
  COLOR: 'color',
  DATE: 'date',
  DATETIME_LOCAL: 'datetime-local',
  EMAIL: 'email',
  FILE: 'file',
  HIDDEN: 'hidden',
  IMAGE: 'image',
  MONTH: 'month',
  NUMBER: 'number',
  PASSWORD: 'password',
  RADIO: 'radio',
  RANGE: 'range',
  RESET: 'reset',
  SEARCH: 'search',
  SUBMIT: 'submit',
  TEL: 'tel',
  TEXT: 'text',
  TIME: 'time',
  URL: 'url',
  WEEK: 'week',
}
export const CustomInputTypes = {
  BIRTH_NUMBER: 'customBirthNumber',
  MONEY: 'customMoney',
  REG_PLATE: 'customRegPlate',
  MILEAGE: 'customMileage',
  TECHNICAL_CARD_NO: 'customTechnicalCardNo',
  ZIP: 'customZip',
  FLIGHT_NUMBER: 'customFlightNumber',
  COMPANY_ID: 'customCompanyID',
  VIN: 'customVin'
}
